import { render } from "./TaskTreeNode.vue?vue&type=template&id=0a42552c&scoped=true"
import script from "./TaskTreeNode.vue?vue&type=script&lang=js"
export * from "./TaskTreeNode.vue?vue&type=script&lang=js"

import "./TaskTreeNode.vue?vue&type=style&index=0&id=0a42552c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a42552c"]])

export default __exports__